



























































import {Component, Prop, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import {categories} from "@/entity/CategoryEntity";
import Select35 from "@/components/inputs/Select35.vue";
import TextField from "@/components/inputs/TextField.vue";
class keyword{
    origin!:string;
    change!:string;
}
class requestPayload{
    cat_id!:number;
    new_cat_id!:number;
    name!:string;
    stock_code!:string;
    enabled:boolean = false;
    keywords:keyword[] = [];
}
@Component({
    components:{
        TextField,
        EForm,Number,EnabledSwitch,Select35
    }
})
export default class CategoryCopyButton extends Vue {
    @Prop({required:true,default:[]}) categories_!:categories[];
    data:requestPayload = new requestPayload();
    dialog = false;
    item:keyword = new keyword();
    created(){
        console.log("created");
        this.getCache();
    }
    getCache(){
        let keywords = localStorage.getItem("copykeywords");
        if(keywords){
            this.data.keywords = JSON.parse(keywords);
        }
    }
    addKeyword(){
        this.data.keywords.push(this.item);
        this.item = new keyword();
        localStorage.setItem("copykeywords",JSON.stringify(this.data.keywords));
    }
    success(data:any){
        this.dialog = false;
        this.data = new requestPayload();
        this.getCache();
        this.$emit("success",data);
    }

}
